import React from 'react';
import { FormAccordion, FormAccordionItem } from 'src/UI/dynamicUI/layout/DynamicEntitySection';
import { Grid } from '@mantine/core';
import { ProductFormComponentProps } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormHelpers';
import { GridPair } from 'src/financial/financial-data/financial-item/forms/common/GridPair';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';
import { GenericFinancialItemFormWrapper } from 'src/financial/financial-data/financial-item/forms/GenericFinancialItemFormWrapper';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ValuationAccordionItem } from 'src/financial/financial-data/financial-item/rework/ValuationAccordionItem';
import { VALUATION_SECTION } from 'src/financial/financial-data/financial-item/rework/financialItemRework';

const CRYPTO = 'Crypto';

export function Crypto(props: ProductFormComponentProps) {
  const { flagEnabledFinancialRework } = useFlags();
  return (
    <GenericFinancialItemFormWrapper title={'Assets > Crypto'} {...props} product={CRYPTO}>
      <FormAccordion defaultValue={[VALUATION_SECTION, 'summary']}>
        <ValuationAccordionItem product={CRYPTO} />
        <FormAccordionItem value="summary" label="Summary">
          <Grid>
            <GridPair
              first={<FinancialFormField field="type" product={CRYPTO} />}
              second={<FinancialFormField field="description" product={CRYPTO} />}
            />
            <GridPair
              isHighlighted
              hide={flagEnabledFinancialRework}
              first={<FinancialFormField field="value" product={CRYPTO} />}
              second={<FinancialFormField field="value_date" product={CRYPTO} />}
            />
            <GridPair fullWidth first={<FinancialFormField field="notes" product={CRYPTO} />} />
          </Grid>
        </FormAccordionItem>
      </FormAccordion>
    </GenericFinancialItemFormWrapper>
  );
}
